<template>
  <!-- TODO - TEST ON MOBILE -->
  <div
    v-if="open"
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
    Background overlay, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-900 opacity-50"></div>
    </div>

    <!--
    Modal panel, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      To: "opacity-100 translate-y-0 sm:scale-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100 translate-y-0 sm:scale-100"
      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  -->
    <div
      v-on-clickaway="closeModal"
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
        <button
          type="button"
          @click="closeModal"
          class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
          aria-label="Close"
        >
          <svg
            class="h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
      <div class="sm:flex sm:items-start">
        <div
          class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-gray-200 sm:mx-0"
        >
          <!-- TODO - ICON COMPONENT -->
          <i class="material-icons text-3xl">supervisor_account</i>
        </div>
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Add New Advisor
          </h3>
          <div class="mt-2 w-full">
            <!-- TODO - FIX TABBING ORDER WHEN DEALING WITH THIS FORM -->
            <!-- https://www.npmjs.com/package/vue-focus-lock -->
            <!-- https://github.com/davidtheclark/focus-trap -->
            <form id="advisorDetails" ref="advisorDetails">
              <!-- TODO - WHAT ELSE MIGHT WE WANT TO SAVE? -->
              <!-- TODO - ADD VALIDATION -->
              <!-- TODO - MAKE INPUT COMPONENT -->
              <!-- TODO - RANDOMIZE PLACEHOLDER WITH FUN VALUES -->
              <label class="block text-left">
                <span class="text-gray-700 text-sm">Name</span>
                <input
                  v-model="name"
                  ref="name"
                  type="text"
                  class="form-input mt-1 block w-full text-sm"
                  placeholder="Tony Stark"
                  required
                />
              </label>

              <label class="block text-left mt-2">
                <span class="text-gray-700 text-sm">Email</span>
                <!-- TODO - MAKE SURE WE DONT GET WEIRD AUTOCOMPLETE VALUES -->
                <input
                  v-model="email"
                  ref="email"
                  type="email"
                  class="form-input mt-1 block w-full text-sm"
                  placeholder="james@bond.com"
                  required
                />
                <p class="mt-2 text-sm text-gray-500" id="email-description">
                  Please only submit advisor requests for people you have an
                  existing relationship with.
                  <!-- TODO - ADD LINK TO SUPPORT ARTICLE ABOUT FINDING MENTORS -->
                </p>
              </label>
            </form>
          </div>
        </div>
      </div>
      <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <!-- TODO - STANDARDIZE BUTTONS ACROSS APP -->
          <button
            type="button"
            @click="addAdvisor"
            class="inline-flex justify-center items-center w-full rounded-md border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:bg-blue-700 focus:border-blue-700 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >
            <span :class="{ 'opacity-0': loading }">
              Add Advisor
            </span>
            <div class="loader absolute" :class="{ 'opacity-0': !loading }" />
          </button>
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <button
            type="button"
            @click="closeModal"
            class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from "vue-clickaway";

export default {
  name: "AddAdvisorModal",
  directives: {
    onClickaway,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      name: "",
      email: "",
      loading: false,
    };
  },
  computed: {
    isValidName() {
      return this.name.length;
    },
    isValidEmail() {
      return this.email.length && this.email.includes("@");
    },
  },
  methods: {
    async addAdvisor() {
      if (!this.$refs.advisorDetails.reportValidity()) {
        return;
      }
      // TODO - CONFIRM WITH SPARKPOST ADDRESS IS VALID
      // TODO - ADD LOADING INDICATOR AND/OR WAIT FOR RESPONSES
      // TODO - BETTER VALIDATION UI

      // TODO - REACT TO SUCCESS OR FAILURE
      // TODO - FLAG THIS AS TEST WHEN LOCALHOST
      this.loading = true;
      await this.$store.dispatch("advisors/addAdvisor", {
        name: this.name,
        email: this.email,
      });

      this.closeModal();
    },
    closeModal() {
      this.name = "";
      this.email = "";
      this.loading = false;
      this.$emit("update:open", false);
    },
  },
  watch: {
    open(newVal) {
      if (newVal) {
        // TODO - EXPAND THIS TO ALL MODALS AND FOCUS FIRST INPUT
        this.$nextTick(() => {
          this.$refs.name.focus();
        });
      }
    },
  },
};
</script>

<style scoped>
/* TODO - REFACTOR INTO COMPONENT */
.loader {
  border: 0.125rem solid #f3f3f3;
  border-top: 0.125rem solid transparent;
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
